<mat-sidenav-container class="trans-overlay" id="main-drawer-container" >
<div class="module-container animated faster fadeInUp">

	<div class="module-bar-fixed">
		<button mat-icon-button color="accent" (mousedown)="goBack()">
			<mat-icon svgIcon="arrow_next" class="rotate-ltr"></mat-icon>
		</button>

		<span class="title text-truncate">
			<span>{{'TD.menu_title' | translate}}</span>
		</span>

		<button mat-icon-button (mousedown)="searchCatalog()">
			<mat-icon svgIcon="search"></mat-icon>
		</button>

		<button id="btnShoppingCart" mat-icon-button color="accent" (mousedown)="checkout()"
				[matBadge]="orderItemsService.$storage?.basket.length"
				[matBadgeHidden]="!orderItemsService.$storage?.basket.length"
				matBadgeColor="accent">
			<mat-icon svgIcon="shopping-cart"></mat-icon>
		</button>
	</div>

	<div class="module-body">
		<app-menu *ngIf="!loading"></app-menu>
	</div>
	<div class="ac-color p-3 pb-4 fixed-bottom" [class.fixedHidden]="!orderItemsService.$storage?.basket[0]">
		<button class="btn-checkout" type="button" (click)="checkout()" id="btnCheckout">
			<div class="_inner">
				<div class="_icon">
					<mat-icon svgIcon="shopping-cart"></mat-icon>
					<div class="_counter">{{orderItemsService.$storage?.basket.length}}</div>
				</div>
				<div class="_caption">{{'TD.my-order' | translate}}</div>
				<div class="_price">{{$storage.order.grandTotal | lcurrency}}</div>
				<div class="_next"><mat-icon>{{appService.nextIcon}}</mat-icon></div>
			</div>
		</button>
	</div>
</div>
</mat-sidenav-container>

<!--<app-power-by-tabit></app-power-by-tabit>-->
